// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonBlok_root__blCtb","button":"ButtonBlok_button__h3VK4"};